// adminApi.js
import axios from "axios";

const CREDIT_TRANSFER_API_SERVICE = `${process.env.REACT_APP_API_URL}/adminservice/api/creditTransfer`;

const apiClient = axios.create({
  baseURL: CREDIT_TRANSFER_API_SERVICE,
  withCredentials: true,
});

const creditTransferApi = {
  transferCredits: (transferData) => apiClient.post("/transfer", transferData),
};

export default creditTransferApi;
